import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a4a6f9a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4a6f9a')) {
      api.createRecord('2a4a6f9a', component.options)
    } else {
      api.reload('2a4a6f9a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a4a6f9a&", function () {
      api.rerender('2a4a6f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/history/master/index.vue"
export default component.exports